import { createSelector } from 'reselect';
import { getThumbnailFileInfo } from './getThumbnailFileInfo';
import { FileHelperService } from '../services';
const getFileInfoState = (state, currentFileId) => state;
const getCurrentFileId = (state, currentFileId) => currentFileId;
export const getModalFileData = createSelector([getFileInfoState, getCurrentFileId], (fileInfoState, fileId) => {
    const currentFileInfo = fileInfoState.byId[fileId];
    const thumbnailInfo = getThumbnailFileInfo(fileInfoState, fileId);
    return {
        fileName: currentFileInfo.fileName,
        fileSize: currentFileInfo.fileSizeInBytes,
        isDone: FileHelperService.getIsFileUploadDone(currentFileInfo, thumbnailInfo),
        status: FileHelperService.getUploadStatus(currentFileInfo, thumbnailInfo),
        isUploadFailed: FileHelperService.getIsFileUploadFailed(currentFileInfo, thumbnailInfo),
        id: currentFileInfo.id,
        thumbnailImage: FileHelperService.getIsFileUploadDone(currentFileInfo, thumbnailInfo)
            ? thumbnailInfo === null || thumbnailInfo === void 0 ? void 0 : thumbnailInfo.file
            : undefined
    };
});
//# sourceMappingURL=getModalFileData.js.map